/**
 * 三方数据源（业务凭证）
 */
import Ajax from '../js/common/ajax';
import Utils from '../js/common/utils';
import axios from 'axios';

export default {
	definition: {
		list() {
			return Ajax.get("/tripartite/definition")
		},
		simple() {
			return Ajax.get("/tripartite/definition/simple")
		},
		load(id) {
			return Ajax.get(`/tripartite/definition/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/tripartite/definition`, params)
		},
		update(id, params = {}) {
			return Ajax.put(`/tripartite/definition/${id}`, params)
		},
		delete(id) {
			return Ajax.delete(`/tripartite/definition/${id}`)
		},
		exportOne(id) {
			return axios.get(`/api/tripartite/definition/${id}/export`, {
				responseType: 'blob',
				headers: {author: Utils.getAuthor() || 'gson', 'X-Requested-With': 'XMLHttpRequest'}
			})
		},
		exportAll() {
			return axios.get(`/api/tripartite/definition/export-all`, {
				responseType: 'blob',
				headers: {author: Utils.getAuthor() || 'gson', 'X-Requested-With': 'XMLHttpRequest'}
			})
		},
		import(params) {
			return Ajax.post(`/tripartite/definition/import`, params, {'Content-Type': 'multipart/form-data'})
		},
		template: {
			list(definitionId) {
				return Ajax.get(`/tripartite/definition/${definitionId}/voucher-tpl`)
			},
			save(definitionId, params = {}) {
				return Ajax.post(`/tripartite/definition/${definitionId}/voucher-tpl`, params)
			},
			delete(definitionId, tid) {
				return Ajax.delete(`/tripartite/definition/${definitionId}/voucher-tpl/${tid}`)
			}
		}
	},
	data: {
		page(definitionId, params = {}, filters = {}) {
			let page = params.page || 1;
			let size = params.size || 20;
			return Ajax.post(`/tripartite/data/${definitionId}/page?page=${page}&size=${size}`, filters)
		},
		save(definitionId, params = {}) {
			return Ajax.post(`/tripartite/data/${definitionId}`, params)
		},
		delete(definitionId, rid) {
			return Ajax.delete(`/tripartite/data/${definitionId}/${rid}`)
		},
		batchDelete(definitionId, ids = []) {
			return Ajax.post(`/tripartite/data/${definitionId}/batch-delete`, ids)
		},
		template(definitionId) {
			return axios.get(`/api/tripartite/data/${definitionId}/template`, {
				responseType: 'blob',
				headers: {author: Utils.getAuthor() || 'gson', 'X-Requested-With': 'XMLHttpRequest'}
			})
		},
		import(definitionId, params) {
			return Ajax.post(`/tripartite/data/${definitionId}/import`, params, {'Content-Type': 'multipart/form-data'})
		},
		download(definitionId, params = {}) {
			return axios.post(`/api/tripartite/data/${definitionId}/download`, params, {
				responseType: 'blob',
				headers: {author: Utils.getAuthor() || 'gson', 'X-Requested-With': 'XMLHttpRequest'}
			})
		},
		generateVoucher(definitionId, vouchers = []) {
			return Ajax.post(`/tripartite/data/${definitionId}/generate-voucher`, vouchers)
		}
	}
}
